import React, { FC, useMemo, useState } from 'react';
import styled from 'styled-components';
import useMeasure from 'react-use-measure';
import { parseHtmlFromString } from 'src/lib/parseHtmlFromString';
import { SectionTitle } from 'src/common/components/SectionTitle';
import { SectionContent } from 'src/common/components/SectionContent';
import { Button } from 'src/common/components/Button';

const Trim = styled.div`
  position: relative;
  max-height: 300px;
  overflow-y: hidden;

  &.descriptionOverflow:after {
    content: '';
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    pointer-events: none;
    background-image: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1) 90%
    );
    width: 100%;
    height: 50px;
  }
`;

const StyledButton = styled(Button)`
  margin-top: 0.75rem;
`;

interface CourseBundleSectionProps {
  heading: string;
  content: string;
}

export const CourseBundleSection: FC<CourseBundleSectionProps> = ({ heading, content }) => {
  const [ref, bounds] = useMeasure();
  const [fullText, setFullText] = useState(false);

  const descriptionOverflow = useMemo(() => bounds.height > 300, [bounds]);
  const parsedContent = useMemo(() => parseHtmlFromString(content), [content]);

  return (
    <>
      <SectionTitle>{parseHtmlFromString(heading)}</SectionTitle>
      {fullText ? (
        <SectionContent>{parsedContent}</SectionContent>
      ) : (
        <Trim className={descriptionOverflow ? 'descriptionOverflow' : ''}>
          <SectionContent ref={ref}>{parsedContent}</SectionContent>
        </Trim>
      )}
      {fullText ? (
        <StyledButton onClick={() => setFullText(false)}>Ukryj</StyledButton>
      ) : (
        bounds.height > 300 && (
          <StyledButton onClick={() => setFullText(true)}>Pokaż więcej</StyledButton>
        )
      )}
    </>
  );
};
